import { CREATE_DMX_CONTROLLER, CREATE_DMX_CONTROLLER_SUCCESSFUL, CREATE_DMX_CONTROLLER_FAILED } from './actionTypes';

const initialState = {
  createDmxControllerError: null,
  messageDmxController: null,
  loadingCreateDmxController: false,
};

const createController = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_DMX_CONTROLLER:
      state = { ...state, loadingCreateDmxController: true, createDmxControllerError: null };
      break;
    case CREATE_DMX_CONTROLLER_SUCCESSFUL:
      state = { ...state, loadingCreateDmxController: false, messageDmxController: action.payload, createDmxControllerError: null };
      break;
    case CREATE_DMX_CONTROLLER_FAILED:
      state = { ...state, messageDmxController: null, loadingCreateDmxController: false, createDmxControllerError: action.payload };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default createController;
